import { Component, CUSTOM_ELEMENTS_SCHEMA, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, RouterOutlet } from '@angular/router';
import { SignalService } from './../services/signal.service';
import { AccountMembership } from './API.service.custom';
import { DataShareService } from 'services/data-share.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { UploadQueueService } from 'services/upload-queue.service';
import { setMaskPhoneNumberEnabled, setCurrentUserId } from './core/amplify-shim';
import { RouteAccessEnforcer } from './core/access/route-access-enforcer.service';


@Component({
    // tslint:disable-next-line
    selector: 'body',
    template: '<router-outlet></router-outlet>@if (!buyerPresentation) { <dialer-widget></dialer-widget> }',
    styleUrls: ['./app.component.scss'],
    providers: [],
    imports: [RouterOutlet],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent implements OnInit, OnDestroy {
  get buyerPresentation(): boolean {
    let route = this.router.routerState.snapshot.root;
    while (route.firstChild && !route.data?.['buyerPresentation']) route = route.firstChild;
    return !!route.data?.['buyerPresentation'];
  }
  currentRoute;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private os: SignalService,
    private uploads: UploadQueueService,
    private dataService: DataShareService, private toastr: ToastrService,
    private routeAccessEnforcer: RouteAccessEnforcer,
  ) {
    // Nav-time route access enforcement now lives in AccessGuard
    // (canActivateChild on the shell route in app.routing.ts), which reads the
    // route's `data.access` policy key and cancels navigation via UrlTree.
    // Cold-load / account-switch re-checks run in the getActiveAccount
    // subscription below through RouteAccessEnforcer. This replaces the previous
    // per-route startsWith redirect blocks that were duplicated here and in
    // DefaultLayoutComponent.
    router.events.pipe(
      filter(event => event instanceof NavigationStart),
      takeUntil(this.destroy$)
    ).subscribe(event => {
        this.currentRoute = (event as NavigationStart).url;
      });


  }

  activeAccount: AccountMembership = null;
  activAccountSubscription

  ngOnInit() {
    this.os.onInit();

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.activAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
        this.activeAccount = param;
        // Enable/disable phone number masking based on account permission
        setMaskPhoneNumberEnabled(!!param.mask_number_permission);
        if (param.userId) {
          setCurrentUserId(param.userId);
        }
        // Layer B: re-check the currently committed route now that the account
        // is known (covers cold deep-links the guard let through, and account switches).
        this.routeAccessEnforcer.enforceCurrentRoute(this.activeAccount);
      }
    })

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.activAccountSubscription && !this.activAccountSubscription.closed)
      this.activAccountSubscription.unsubscribe();
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(e: BeforeUnloadEvent) {
    if (this.uploads.hasPending()) {
      e.preventDefault();      // some browsers
      e.returnValue = '';      // Chrome/Edge requirement
      return '';               // Safari/old browsers
    }
  }

}
